export const LOAD = 'ethstats/blockTime/LOAD';
export const LOAD_SUCCESS = 'ethstats/blockTime/LOAD_SUCCESS';
export const LOAD_FAIL = 'ethstats/blockTime/LOAD_FAIL';
